import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import pull from 'lodash/pull';
import concat from 'lodash/concat';
import Select from '../../../../modules/react/components/stateful/Select';

const options = [
  { value: 'bold', label: 'bold' },
  { value: 'italic', label: 'italic' },
  { value: 'strikethrough', label: 'strikethrough' },
  { value: 'underline', label: 'underline' },
];

export default class ClassSelector extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    handleChange: PropTypes.func,
    instanceId: PropTypes.string,
    selectedOptions: PropTypes.array,
  };

  handleChange = (option) => {
    const { value } = option[0];
    let { selectedOptions } = this.props;

    if (includes(selectedOptions, value)) {
      selectedOptions = pull(selectedOptions, value);
    } else {
      selectedOptions = concat(selectedOptions, value);
    }

    this.props.handleChange(selectedOptions);
  };

  renderOption = ({ value }) => (
    <div>
      <input type="checkbox" defaultChecked={includes(this.props.selectedOptions, value)} />
      {' '}<span className={value}>{value}</span>
    </div>
  );

  render() {
    const { className, selectedOptions, instanceId } = this.props;

    return (
      <div>
        <Select
          autoBlur
          className={className}
          clearable={false}
          instanceId={instanceId}
          multi
          onChange={this.handleChange}
          optionRenderer={this.renderOption}
          options={options}
          placeholder={
            selectedOptions.length ?
              <span style={{ color: '#000' }}>{selectedOptions.join(', ')}</span>
              : 'choose formatting'
          }
          searchable={false}
        />
      </div>
    );
  }
}
